<template>
  <v-content class="bibi mt-12">
    <v-row justify="center" align="center">
      <v-col>
       
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col>
           <h2 class="font-weight-thin d-flex justify-center">Coucou ma Bibi !</h2>
           <h2 class="font-weight-thin d-flex justify-center">Dress up and be ready in:</h2>
        <countdown />
        <h3 class="font-weight-thin d-flex justify-center">... Merry Chistmas ;-)</h3>
      </v-col>
    </v-row>
  </v-content>
</template>

<script>
import Countdown from "../components/Countdown.vue";

export default {
  name: "bibi",
  components: {
    Countdown,
  },
  data() {
    return {
      data: "",
    };
  },
};
</script>

<style Scoped></style>
